import { jwtDecode } from "jwt-decode";
import api from "@/api";
import eventBus from "@/utils/eventBus";

export async function checkAuth() {
    const accessToken = localStorage.getItem('accessToken');
    const refreshToken = localStorage.getItem('refreshToken');

    if (accessToken) {
        try {
            const decoded = jwtDecode(accessToken);
            const exp = decoded.exp * 1000;
            if (exp < Date.now()) {
                if (refreshToken) {
                    const response = await api.get('/v1/auth/refresh', {
                        headers: {
                            Authorization: `Bearer ${refreshToken}`
                        }
                    });
                    if (response.status === 200) {
                        const responseObject = response.data;
                        
                        localStorage.setItem('accessToken', responseObject.data.accessToken);
                        localStorage.setItem('refreshToken', responseObject.data.refreshToken);
                        console.log('User tokens refreshed.');
                        
                        return true;
                    } else {
                        localStorage.removeItem('accessToken');
                        localStorage.removeItem('refreshToken');
                        console.log(`Refresh failed. Response: ${response.status}`);
                        
                        return false;
                    }
                } else {
                    localStorage.removeItem('accessToken');
                    localStorage.removeItem('refreshToken');
                    
                    return false;
                }
            }
            
            return true;
        } catch (err) {
            console.error(err);
            localStorage.removeItem('accessToken');
            localStorage.removeItem('refreshToken');
            return false;
        }
    } else {
        return false;
    }
}

export async function triggerMFA() {
    if (!(await checkAuth())) {
        eventBus.emit('show-alert', { message: 'You need to log in to access this page.', type: 'danger' });
        this.$router.push('/');
    } else {
        const response = await api.get('/v1/auth/mfa', {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('accessToken')}`
            }
        });
        if (response.status === 200) {
            const data = response.data;
            localStorage.setItem('mfaSecret', data.data.otpChecker);
            eventBus.emit('show-alert', { message: 'Verification code sent to your email.', type: 'success' });
        } else {
            eventBus.emit('show-alert', { message: 'Error generating verification code. Try again.', type: 'danger' });
        }
    }
}

export async function getAuthorities() {
    const accessToken = localStorage.getItem('accessToken');
    if (accessToken) {
        try {
            const decoded = jwtDecode(accessToken);
            return decoded.authorities.split(',');
        } catch (err) {
            console.error(err);
            return [];
        }
    } else {
        return [];
    }
}